var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotUrgent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5999 40.0836L43.2832 2.68359C42.5832 3.16693 41.9832 3.80026 41.5332 4.56693L13.1165 53.8003C12.6665 54.5836 12.4165 55.4169 12.3499 56.2503L47.3999 42.1669C48.2332 41.8336 48.7332 40.9669 48.5999 40.0836Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4666 39.5337C52.65 40.867 52.3833 42.1837 51.75 43.2837C51.1166 44.3837 50.1166 45.2837 48.8666 45.7837L13.3833 60.0503C13.8666 60.7503 14.5 61.3503 15.2666 61.8003L42.55 77.5503C45.35 79.167 48.9333 78.2003 50.55 75.4003L78.9666 26.167C80.5833 23.367 79.6166 19.7837 76.8166 18.167L49.5333 2.43366C48.75 1.98366 47.9166 1.73366 47.0833 1.66699L52.4666 39.5337Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8999 22.9836V23.2003C9.8999 24.7098 11.1237 25.9336 12.6332 25.9336H22.3332C23.8428 25.9336 25.0666 24.7098 25.0666 23.2003V22.9836C25.0666 21.474 23.8428 20.2503 22.3332 20.2503H12.6332C11.1237 20.2503 9.8999 21.474 9.8999 22.9836Z",
    fill: "#0F0F0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 34.4498V34.4665C1.66675 36.0313 2.93527 37.2998 4.50008 37.2998H15.9834C17.5482 37.2998 18.8167 36.0313 18.8167 34.4665V34.4498C18.8167 32.885 17.5482 31.6165 15.9834 31.6165H4.50008C2.93527 31.6165 1.66675 32.885 1.66675 34.4498Z",
    fill: "#0F0F0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotUrgent);
export default __webpack_public_path__ + "static/media/NotUrgent.a820cc71.svg";
export { ForwardRef as ReactComponent };